import { CheckboxCheckedFilled, ErrorCircleFilled } from '@fluentui/react-icons';
import { Divider, Tooltip } from '@fluentui/react-components';
import moment from 'moment';
import React from 'react';
import { MessagingColors } from '../../../app/common/styles/CommonStyleObjects';
import StatDateFormats from '../../../utils/types/DateFormats';
import SpanWithLabel from '../../common/SpanWithLabel';

interface IStepItemProps {
  step: {
    id: number;
    name: string;
    status: string;
    created: string;
  };
}

const getColorAndIcon = (status: string) => {
  if (status === 'Failed') {
    return {
      color: MessagingColors.errorBlockIcon,
      icon: <ErrorCircleFilled />,
    };
  }

  return {
    color: MessagingColors.successIcon,
    icon: <CheckboxCheckedFilled />,
  };
};

const StepItem = (props: IStepItemProps) => {
  const { step } = props;
  const { color, icon } = getColorAndIcon(step.status);

  const createdTime = moment(step.created).format(StatDateFormats.DayWithTime);
  return (
    <Tooltip
      withArrow
      content={
        <div style={{ minWidth: '200px' }}>
          <SpanWithLabel labelText="Step Name" value={step.name} />
          <Divider />
          <SpanWithLabel labelText="Started" value={createdTime} />
        </div>
      }
      relationship="label"
    >
      <div style={{ color }}>{icon}</div>
    </Tooltip>
  );
};

export default StepItem;
